// extracted by mini-css-extract-plugin
export default {"reserve_totals_wrapper":"ReserveWorksheet_reserve_totals_wrapper__U23jK","reserve_header":"ReserveWorksheet_reserve_header__YC8k+"};